/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PhysicianScheduleBlockIndividualAliases {
  GLOBAL_ACTIONS_PHYSICIAN_SCHEDULE_BLOCK = 'global-actions-physician-schedule-block',
  PHYSICIAN_SCHEDULE_BLOCK_CONTEXTUAL_BAR = 'physician-schedule-block-contextual-bar',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_BUTTON = 'physician-schedule-block-individual-button',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_DECK = 'physician-schedule-block-individual-deck',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_FIELD = 'physician-schedule-block-individual-field',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_LAYOUT = 'physician-schedule-block-individual-layout',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_TITLE = 'physician-schedule-block-individual-title',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_TITLE_PANEL = 'physician-schedule-block-individual-title-panel',
  PHYSICIAN_SCHEDULE_CARD_LIST_PANEL = 'physician-schedule-card-list-panel',
  PHYSICIAN_SCHEDULE_INDIVIDUAL_0 = 'physician-schedule-individual-0',
  PHYSICIAN_SCHEDULE_UNLOCK_INDIVIDUAL_BUTTON = 'physician-schedule-unlock-individual-button',
}
export { PhysicianScheduleBlockIndividualAliases };
